export default __webpack_public_path__ + "static/media/logopp.9e53c067.png";